import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../recommendations.css";
import { searchProfile } from "../../store/slices/preference";
import {
  sendInterest,
  shortlistUser,
} from "../../store/slices/intrestandshortlisted";
import { toast } from "react-toastify";
import {
  sendMessage,
  getConversationByUser,
  getMessages,
} from "../../store/slices/chat";
import { Container } from "react-bootstrap";
import { IoFilterSharp } from "react-icons/io5";

function scoreColor(score) {
  if (score >= 90) return { bg: "#fef9ec", border: "#f5c842", text: "#b07820" };
  if (score >= 80) return { bg: "#f0fdf4", border: "#86efac", text: "#16a34a" };
  return { bg: "#fdf6f0", border: "#f0c0a0", text: "#b05020" };
}

export default function Recommendations() {
  const [showFilter, setShowFilter] = useState(false);
  const dispatch = useDispatch();
  const [activeChatUser, setActiveChatUser] = useState(null);
  const [conversationId, setConversationId] = useState(null);

  const { searchResults = [], searchLoading } = useSelector(
    (state) => state.preference,
  );

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  //  LOCAL STATE FOR UI UPDATE
  const [profiles, setProfiles] = useState([]);

  // ── NEW: mobile bottom-sheet open/close state ──
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;

  useEffect(() => {
    dispatch(searchProfile({}));
  }, [dispatch]);

  useEffect(() => {
    setProfiles(searchResults);
  }, [searchResults]);

  const navigate = useNavigate();

  const lastScrollY = useRef(0);
  const [fabHidden, setFabHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      setFabHidden(currentY > lastScrollY.current && currentY > 80);
      lastScrollY.current = currentY;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ── NEW: lock body scroll when mobile sheet is open ──
  useEffect(() => {
    document.body.style.overflow = mobileFilterOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileFilterOpen]);

  const [filter, setFilter] = useState({
    subcaste: "",
    caste: "",
    age: "",
    height: "",
  });

  const activeFilterCount = Object.values(filter).filter(
    (v) => v !== "",
  ).length;

  const resetFilters = () =>
    setFilter({ subcaste: "", caste: "", age: "", height: "" });


  const handlesendIntrested = async (userId) => {

    setProfiles((prev) =>
      prev.map((p) =>
        p._id === userId ? { ...p, interestSent: "pending" } : p,
      ),
    );

    try {
      const res = await dispatch(sendInterest({ toUserId: userId })).unwrap();

      if (res?.success) {
        toast.success(res?.message || "Interest sent successfully!");
      }
    } catch (err) {

      setProfiles((prev) =>
        prev.map((p) => (p._id === userId ? { ...p, interestSent: null } : p)),
      );

      toast.error(err || err?.data?.message || "Failed to send interest.");
    }
  };


  const handleShortlisted = async (userId) => {

    setProfiles((prev) =>
      prev.map((p) => (p._id === userId ? { ...p, isShortlisted: true } : p)),
    );

    try {
      const res = await dispatch(shortlistUser({ toUserId: userId })).unwrap();

      if (res?.success) {
        toast.success(res?.message || "User shortlisted successfully!");
      }
    } catch (err) {

      setProfiles((prev) =>
        prev.map((p) =>
          p._id === userId ? { ...p, isShortlisted: false } : p,
        ),
      );

      toast.error(err || err?.data?.message || "Failed to shortlist user.");
    }
  };

  const handleSendMessage = async () => {
    if (!message.trim() || !activeChatUser) return;

    const payload = {
      toUserId: activeChatUser._id,
      text: message,
    };

    const tempMsg = {
      text: message,
      sender: userId,
      createdAt: new Date(),
    };

    setMessages((prev) => [...prev, tempMsg]);
    setMessage("");

    try {
      const res = await dispatch(sendMessage(payload)).unwrap();

      if (!res?.data) return;

      setMessages((prev) => [...prev.slice(0, -1), res.data]);
    } catch (err) {
      console.error(err);
    }
  };


  const FilterContent = () => (
    <>
      <div className="filter-group">
        <label className="filter-label">Age</label>
        <select
          className="filter-select"
          value={filter.age}
          onChange={(e) => setFilter({ ...filter, age: e.target.value })}
        >
          <option value="">Any</option>
          <option value="25">Below 25</option>
          <option value="28">Below 28</option>
          <option value="30">Below 30</option>
        </select>
      </div>

      <div className="filter-group">
        <label className="filter-label">Subcaste</label>
        <select
          className="filter-select"
          value={filter.caste}
          onChange={(e) => setFilter({ ...filter, caste: e.target.value })}
        >
          <option value="">Any</option>
          <option value="Sadar">Sadar</option>
          <option value="Panchamasali">Panchamasali</option>
          <option value="Banajiga">Banajiga</option>
        </select>
      </div>

      <div className="filter-group">
        <label className="filter-label">Height</label>
        <select
          className="filter-select"
          value={filter.height}
          onChange={(e) => setFilter({ ...filter, height: e.target.value })}
        >
          <option value="">Any</option>
          <option value="5'1&quot;">5'1"</option>
          <option value="5'4&quot;">5'4"</option>
          <option value="5'5&quot;">5'5"</option>
        </select>
      </div>
    </>
  );

  return (
    <>
      <Container fluid>

        <div className="ps-root">
          <div className="ps-header">
            <div className="ps-header-title">
              Today's Recommendations <span>✦</span>
            </div>
            <div className="ps-count">
              Showing <strong>{profiles.length}</strong> compatible profiles
            </div>
          </div>

          <div className="ps-layout">

            <div className="ps-sidebar">


              <div className="legend-card">
                <div className="legend-title">Match Score Guide</div>
                <div className="legend-item">
                  <div className="legend-dot" style={{ background: "#f5c842" }} />
                  90%+ · Highly Compatible
                </div>
                <div className="legend-item">
                  <div className="legend-dot" style={{ background: "#86efac" }} />
                  80–89% · Good Match
                </div>
                <div className="legend-item">
                  <div className="legend-dot" style={{ background: "#fda97a" }} />
                  Below 80% · Partial Match
                </div>
              </div>
            </div>

            {/* ── PROFILES ── */}
            <div className="ps-main">
              {searchLoading ? (

                [1, 2, 3, 4].map((i) => (
                  <div key={i} className="ep-skeleton-card profile-card">

                    <div className="card-photo">
                      <div className="ep-skeleton-square" style={{ height: "250px", width: "100%" }} />
                    </div>


                    <div className="card-body">
                      <div className="card-top">
                        <div style={{ flex: 1 }}>
                          <div className="ep-skeleton-title" />
                          <div
                            className="ep-skeleton-line short"
                            style={{ marginTop: 6 }}
                          />
                        </div>

                        <div className="ep-skeleton-circle" />
                      </div>


                      <div
                        className="info-chips"
                        style={{ marginTop: 10, display: "flex", gap: 8 }}
                      >
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 80, borderRadius: 20 }}
                        />
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 90, borderRadius: 20 }}
                        />
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 70, borderRadius: 20 }}
                        />
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 75, borderRadius: 20 }}
                        />
                      </div>

                      {/* Detail grid */}
                      <div
                        className="detail-grid"
                        style={{ marginTop: 10, display: "flex", gap: 12 }}
                      >
                        <div style={{ flex: 1 }}>
                          <div
                            className="ep-skeleton-line short"
                            style={{ width: 60, marginBottom: 4 }}
                          />
                          <div className="ep-skeleton-line" style={{ width: 90 }} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <div
                            className="ep-skeleton-line short"
                            style={{ width: 80, marginBottom: 4 }}
                          />
                          <div className="ep-skeleton-line" style={{ width: 100 }} />
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div
                        className="card-actions"
                        style={{ marginTop: 12, display: "flex", gap: 8 }}
                      >
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 120, height: 32, borderRadius: 6 }}
                        />
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 100, height: 32, borderRadius: 6 }}
                        />
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 90, height: 32, borderRadius: 6 }}
                        />
                      </div>
                    </div>
                  </div>
                ))
              ) : profiles.length === 0 ? (
                <div className="filter-card empty-state">
                  <div className="empty-icon">🔍</div>
                  <div className="empty-text">
                    No profiles match your filters.
                    <br />
                    Try adjusting your preferences.
                  </div>
                </div>
              ) : (
                profiles.map((profile) => {
                  const sc = scoreColor(profile.matchScore);
                  return (
                    <div key={profile.id} className="profile-card">
                      {profile.recommended && (
                        <div className="ribbon">✦ Top Match</div>
                      )}

                      {/* Photo */}
                      <div className="card-photo">
                        <img src={profile.profilePhoto} alt={profile.name} />
                        {profile.online && (
                          <div className="online-badge">● Online</div>
                        )}
                        {profile.verified && (
                          <div className="verified-badge">✓ Verified</div>
                        )}
                      </div>

                      {/* Body */}
                      <div className="card-body">
                        <div className="card-top">
                          <div>
                            <div className="card-name">{profile.name}</div>
                            <div className="card-tagline">
                              {profile.age} yrs · {profile?.profile?.height} ·{" "}
                              {profile?.profile?.maritalStatus}
                            </div>
                          </div>

                          {/* Match Score */}
                          <div className="match-score">
                            <div
                              className="score-ring"
                              style={{
                                background: sc.bg,
                                border: `2px solid ${sc.border}`,
                                color: sc.text,
                              }}
                            >
                              {profile.matchScore}%
                            </div>
                            <div className="score-label">match</div>
                          </div>
                        </div>

                        {/* Quick chips */}
                        <div className="info-chips">
                          <span className="chip">
                            <span className="chip-icon">🎓</span>
                            {profile.education}
                          </span>
                          <span className="chip">
                            <span className="chip-icon">💼</span>
                            {profile.occupation}
                          </span>
                          <span className="chip">
                            <span className="chip-icon">📍</span>
                            {profile.city}
                          </span>
                          <span className="chip">
                            <span className="chip-icon">🗣</span>
                            {profile?.profile?.motherTongue}
                          </span>
                        </div>

                        {/* Detail grid */}
                        <div className="detail-grid">
                          <div className="detail-item">
                            <div className="detail-label">Subcaste</div>
                            <div className="detail-val">{profile?.profile?.subCaste}</div>
                          </div>
                          <div className="detail-item">
                            <div className="detail-label">Annual Income</div>
                            <div className="detail-val">
                              {profile?.profession?.annualIncome}
                            </div>
                          </div>
                        </div>

                        {/* Actions */}
                        <div className="card-actions">
                          <button
                            className="btn-interest"
                            onClick={() => handlesendIntrested(profile._id)}
                            disabled={profile.interestSent === "pending"}
                          >
                            {profile.interestSent === "pending"
                              ? "Interest Sent ✓"
                              : profile.interestReceived === "pending"
                                ? "Respond to Interest"
                                : "Send Interest"}
                          </button>
                          <button
                            className="btn-view"
                            onClick={() =>
                              navigate(`/user/profile-details/${profile._id}`)
                            }
                          >
                            View Profile
                          </button>
                          <button
                            className="btn-shortlist btn-shortlist-off"
                            onClick={() => handleShortlisted(profile._id)}
                            disabled={profile.isShortlisted}
                          >
                            {profile.isShortlisted ? "Shortlisted ✓" : "Shortlist"}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>

      </Container>

      <button
        className={`mobile-filter-fab ${fabHidden ? "fab-hidden" : ""}`}
        onClick={() => setMobileFilterOpen(true)}
        aria-label="Open filters"
      >

        <IoFilterSharp />

        {activeFilterCount > 0 && (
          <span className="fab-badge">{activeFilterCount}</span>
        )}
      </button>


      <div
        className={`mobile-filter-overlay ${mobileFilterOpen ? "overlay-visible" : ""}`}
        onClick={() => setMobileFilterOpen(false)}
      />


      <div className={`mobile-filter-sheet ${mobileFilterOpen ? "sheet-open" : ""}`}>


        <div className="sheet-handle" />


        <div className="sheet-header">
          <div>
            <div className="filter-title" style={{ marginBottom: 2 }}>Partner Preferences</div>
            <div className="filter-sub">FILTER PROFILES</div>
          </div>
          <button
            className="sheet-close-btn"
            onClick={() => setMobileFilterOpen(false)}
            aria-label="Close filters"
          >
            ✕
          </button>
        </div>


        <div className="sheet-body">
          <FilterContent />
        </div>

        {/* Footer actions */}
        <div className="sheet-footer">
          <button
            className="sheet-apply-btn"
            onClick={() => setMobileFilterOpen(false)}
          >
            Apply Filters
          </button>
          <button
            className="sheet-reset-btn"
            onClick={() => { resetFilters(); }}
          >
            ↺ Reset
          </button>
        </div>

      </div>

    </>
  );
}